module.exports = __webpack_public_path__ + "img/panda_finance_icon.9fc88630.svg";